import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const TicketSkeletonWrapper = styled(Box)`
  width: 300px;
  height: 150px;
  margin: 10px 7px;
`;
